import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Loader } from "rsuite";

import { useAuth } from "context/auth-context";

import AuthGabarit from "../../components/AuthGabarit";
import CookieBanner from "../../components/CookieBanner";

import { InputEmail, InputPassword } from "../../components/Inputs";
import { useConfig } from "../../context/config-context";

export default function LoginPage() {
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();

  const siteConfig = useConfig();

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      await login(data.email, data.password);
      navigate(siteConfig.routes.dashboard.path);
    } catch (error) {}
    setLoading(false);
  };

  return (
    <AuthGabarit>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col space-y-2"
      >
        <InputEmail id="email" register={register} error={errors.email} />
        <InputPassword
          id="password"
          register={register}
          error={errors.password}
        />
        <a
          href={siteConfig.routes.forgot_password.path}
          className="text-xs text-blue-800 underline w-fit"
        >
          <span className="underline">
            {siteConfig.pages.login.forget_password}
          </span>
        </a>
        <button
          type="submit"
          className="px-10 py-1 mx-auto border rounded w-fit border-primary text-primary hover:bg-primary disabled:bg-transparent hover:text-white"
          disabled={loading}
        >
          {loading ? <Loader /> : siteConfig.pages.login.cta}
        </button>
        <span>
          {siteConfig.pages.login.validate_email.label + " "}
          <a
            href={siteConfig.routes.validate_email.path}
            className="text-blue-800 cursor-pointer hover:opacity-70"
          >
            {siteConfig.pages.login.validate_email.cta}
          </a>
        </span>
      </form>
      <CookieBanner />
    </AuthGabarit>
  );
}
